import React, { useState } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
// import GetAppIcon from '@material-ui/icons/GetApp'
// import AddIcon from '@material-ui/icons/Add'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { Grid } from '@material-ui/core'
// import { getLocationsByForm } from '../../../../../services/Elegibilidad/get'
import { ModalMapsEdit } from '../../Maps/MapsEdit/ModalMapsEdit'
// import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
// import swal from 'sweetalert'

const Table31 = ({ getDataTableLocation, tableDataLocation }) => {
  // const {  DeleteLocationContext } = useFormElegibilidad()

  const [open, setOpen] = useState(false)
  const [dataRow, setDataRow] = useState({})
  const [positionsCurrent, setpositionsCurrent] = useState({})
  const [address, setAddress] = useState('')

  // const handleDelete = async (id) => {
  //   try {
  //     const response = await DeleteLocationContext(id)
  //     return response
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const columns = [
    { title: 'Latitud', field: 'Latitud', filterPlaceholder: 'filter' },
    {
      title: 'Longitud',
      field: 'Longitude',
      align: 'center',
      grouping: false,
    },
    {
      title: 'Dirección ',
      field: 'Address',
      // emptyValue: () => <em>null</em>,
      // render: (rowData) => (
      //   <div
      //     style={{
      //       background: rowData.age >= 18 ? '#008000aa' : '#f90000aa',
      //       borderRadius: '4px',
      //       paddingLeft: 5,
      //     }}
      //   >
      //     {rowData.age >= 18 ? '18+' : '18-'}
      //   </div>
      // ),
      searchable: true,
      export: true,
    },
    // { title: 'Gender', field: 'gender', lookup: { M: 'Male', F: 'Female' } },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableDataLocation}
            actions={[
              {
                icon: () => <VisibilityIcon color="success" />,

                tooltip: 'Ver',
                onClick: (event, rowData) => {
                  setpositionsCurrent({})
                  setDataRow([])
                  setDataRow(rowData)

                  setpositionsCurrent({
                    lat: parseFloat(rowData.Latitud),
                    lng: parseFloat(rowData.Longitude),
                  })
                  setAddress(rowData.Address)
                  setOpen(true)
                },
              },
              // {
              //   icon: () => <DeleteIcon style={{ color: 'red' }} />,
              //   tooltip: 'Eliminar ubicación',
              //   onClick: (event, rowData) => {
              //     swal({
              //       title: '¿Está seguro de eliminar el registro?',
              //       icon: 'warning',
              //       buttons: ['No', 'Si'],
              //       dangerMode: true,
              //     }).then(function (isConfirm) {
              //       if (isConfirm) {
              //         handleDelete(rowData.IdProjectDevelopmentLocation)
              //       }
              //     })
              //   },
              // },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              customFilterAndSearch: 'Address',
              // filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              // addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              // grouping: true,
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={
              {
                // Add: () => <AddIcon />,
                // Edit: () => <EditIcon />,
              }
            }
          />
        </Grid>
      </Grid>
      <ModalMapsEdit
        open={open}
        setOpen={setOpen}
        dataRow={dataRow}
        positionsCurrent={positionsCurrent}
        setpositionsCurrent={setpositionsCurrent}
        address={address}
        setAddress={setAddress}
        getDataTableLocation={getDataTableLocation}
      />
    </div>
  )
}

export default React.memo(Table31)
